/* prettier-ignore */
/** @see {@link https://developer.mozilla.org/en-US/docs/Glossary/Undefined} */
export const SAMPLE_UNDEFINEDES = [
	undefined,
	void 0,
];
